import { Component, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MailshotService } from '../mailshot.service';
import { BaseComponent } from '@app/components/base/base.component';
import { NotificationService } from '../../../services/notifications.service';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { EntitiesServices } from '@app/services/entities.service';
import { AuthService } from '@app/common/auth.service';
import { environment } from '@env/environment.local';
import { ExcelReportService } from '@app/services/reporting';
import { buildMailshotReportConfig } from './mailshot-report.config';

@Component({
  selector: 'app-details-mailshot',
  templateUrl: './details-mailshot.component.html',
  styleUrls: ['./details-mailshot.component.css'],
})
export class DetailsMailshotComponent extends BaseComponent implements OnInit {
  private readonly reports = inject(ExcelReportService);

  users: any[] = [];
  select: any[] = this.service.select;
  input: any[] = [{ value: '', placeholder: 'Buscar usuario' }];
  module: string = '';
  isLoading: boolean = false;
  id: any = '';
  hasData: boolean = true;
  listUSer: any[] = [];

  pages: any[] = [];
  total: number = 0;
  pageSize: number = environment.pageSize;
  pageIndex: number = 0;
  readonly mailshotRecipientsImprovements =
    environment.mailshotRecipientsImprovements;

  params: any = {
    page: this.pageIndex,
    pageSize: this.pageSize,
  };

  filterName: string = '';
  isDownload: any = null;
  profiles: any[] = [];
  dealers: any[] = [];
  data: any;

  constructor(
    route: ActivatedRoute,
    menuService: MenusServices,
    private service: MailshotService,
    private notifications: NotificationService,
    private entitiesService: EntitiesServices,
    private authService: AuthService
  ) {
    super(route, menuService);
    this.module = this.sendDataToMenu();
    this.id = route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    if (this.mailshotRecipientsImprovements) {
      this.authService.dealers
        .pipe(takeUntilDestroyed(this._destroyRef))
        .subscribe((dealers: any) => {
          this.dealers = Array.isArray(dealers) ? dealers : [];
          if (this.listUSer.length) this.filterList();
        });
    }
    this.getDetails();
  }

  getDetails() {
    this.isLoading = true;
    this.service.getDetailsMailshot(this.id).subscribe({
      next: (r: any) => {
        this.data = r.data;
        this.users = r.data.users;
        this.isLoading = false;
        this.listUSer = this.users;
        this.hasData = r.data.users.length > 0;
        if (this.hasData) {
          this.createPages(r.data.users);
        }
        this.getProfiles();
      },
      error: (error: any) => {
        this.isLoading = false;
        this.notifications.showMessage(this.msgFailedConnection, 'error');
      },
    });
  }

  getProfileName(id: number) {
    let profile = this.profiles.find((profile) => profile.id === id);
    return profile ? profile.description : '';
  }

  getProfiles() {
    this.isLoading = true;
    this.entitiesService.listProfiles().subscribe({
      next: (response) => {
        this.isLoading = false;
        this.profiles = response.data;
        if (this.mailshotRecipientsImprovements && this.listUSer.length) {
          this.filterList();
        }
      },
      error: (error) => {
        this.notifications.showMessage(this.msgFailedConnection, 'error');
        this.isLoading = false;
      },
    });
  }

  createPages(list: any[]) {
    const itemsPerPage = this.pageSize; // Establece la cantidad de destinatarios por página
    const sortedList = this.mailshotRecipientsImprovements
      ? [...list].sort(
          (a, b) =>
            this.getDealersName(a.dealerId).localeCompare(
              this.getDealersName(b.dealerId),
              'es',
              { sensitivity: 'base' }
            ) ||
            this.getProfileName(a.profileId).localeCompare(
              this.getProfileName(b.profileId),
              'es',
              { sensitivity: 'base' }
            ) ||
            (a.name ?? '').localeCompare(b.name ?? '', 'es', {
              sensitivity: 'base',
            })
        )
      : list;
    this.pages = [];
    for (let i = 0; i < sortedList.length; i += itemsPerPage) {
      this.pages.push(sortedList.slice(i, i + itemsPerPage));
    }
    this.total = sortedList.length;
    this.hasData = sortedList.length > 0;
    this.users = this.pages[this.pageIndex]; // Mostrar la primera página inicialmente
  }

  filter(value: any, typeSelect: string) {
    switch (typeSelect) {
      case 'user':
        this.filterName = this.mailshotRecipientsImprovements
          ? value.toLowerCase()
          : value;
        break;
      case 'download':
        this.isDownload = value;
        break;
    }
    this.filterList();
  }

  filterList() {
    this.isLoading = true;
    this.pageIndex = 0;

    setTimeout(() => {
      this.isLoading = false;
    }, 1500);

    let results: any[] = [];

    if (this.filterName != '' && this.isDownload == null) {
      // solo filtro por nombre
      results = this.listUSer.filter((i) => i.name.toLowerCase().includes(this.filterName));
    } else if (this.filterName != '' && this.isDownload != null && this.isDownload) {
      // filtro por nombre  y por descargado
      results = this.listUSer.filter((i) => i.name.toLowerCase().includes(this.filterName) && !!i.downloadDate);
    } else if (this.filterName != '' && this.isDownload != null && !this.isDownload) {
      // filtro por nombre  y sin descargar
      results = this.listUSer.filter((i) => i.name.toLowerCase().includes(this.filterName) && !i.downloadDate);
    } else if (this.filterName == '' && this.isDownload == null) {
      // muestro todos
      results = this.listUSer;
    } else if (this.filterName == '' && this.isDownload != null && this.isDownload) {
      // por descargado
      results = this.listUSer.filter((i) => !!i.downloadDate);
    } else if (this.filterName == '' && this.isDownload != null && !this.isDownload) {
      // filtro sin descargar
      results = this.listUSer.filter((i) => !i.downloadDate);
    }

    this.createPages(results);
  }

  handlePage(e: any) {
    if (e.pageIndex != this.pageIndex) this.users = this.pages[e.pageIndex];

    if (e.pageSize != this.pageSize) {
      this.pageSize = e.pageSize;
      this.createPages(this.listUSer);
    }
  }

  isOpen: boolean = false;

  openActions() {
    this.isOpen = !this.isOpen;
  }

  async exportToExcel(): Promise<void> {
    try {
      const config = buildMailshotReportConfig(this.data, {
        getProfileName: (id) => this.getProfileName(id),
        getDealersName: (id) => this.getDealersName(id),
      });
      await this.reports.generate(config);
    } catch {
      this.notifications.showMessage(
        ['Hubo un error al generar el archivo de Excel.'],
        'error',
      );
    }
  }

  getDealersName(id: number) {
    if (!this.mailshotRecipientsImprovements) {
      const dealer = this.authService.currentDealers.find(
        (dealer: { id: number }) => dealer.id === id
      );
      return dealer ? dealer.name : '';
    }
    if (id == null) return '';
    const dealer = this.dealers.find(
      (dealer: { id: number | string }) => String(dealer.id) === String(id)
    );
    return dealer?.name ?? '';
  }
}
